import React, { memo, useMemo } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";

import { pmOperationDataFilter } from "./../Constant";
import PointOperationChart from "./PointOperationChart";
import { Transition } from "../../../Modal/ModalConstants";

function PointChartPopup(props) {
  const { open, onClose, machineData, deviceId, deviceName, currentTs, disableFilter } = props;
  // const processedEventTime = [];
  // const processedEventData = [];

  const processedMachineData = useMemo(() => pmOperationDataFilter(machineData.eventData, machineData.eventTime), []);
  // console.log(processedMachineData)
  // if (machineData.eventTime.length > 0 && machineData.eventData.length > 0) {
  //   const eventTime = machineData.eventTime.split(" ");
  //   const eventData = machineData.eventData.split(" ");

  //   eventTime.forEach((value, index) => {
  //     if (Number(value) !== 0 || index === 0) {
  //       processedEventTime.push(Number(value));
  //     }
  //   });
  //   eventData.filter((value, index) => {
  //     if (Number(value) !== 0 || index === 0) {
  //       processedEventData.push(Number(value));
  //     }
  //   });
  // }

  return (
    <Dialog
      fullScreen
      open={open}
      aria-labelledby="responsive-dialog-title"
      TransitionComponent={Transition}
      fullWidth={true}
      maxWidth={"md"}
    >
      <DialogTitle id="responsive-dialog-title" className="flex">
        {`Point Machine Operation Chart (${deviceName})`}
        <CloseIcon
          className="pointer"
          sx={{ ml: "auto" }}
          onClick={() => {
            onClose(false);
          }}
        />
      </DialogTitle>
      <DialogContent
        // sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
        dividers
      >
        <PointOperationChart
          deviceId={deviceId}
          // deviceName={deviceName}
          currentTs={currentTs}
          axisData={processedMachineData.time}
          lineData={processedMachineData.data}
          disableFilter={disableFilter}
        />
      </DialogContent>
      {/* <DialogActions>
        <Button
          variant="contained"
          autoFocus
          onClick={() => {
            onClose(false);
          }}
        >
          close
        </Button>
      </DialogActions> */}
    </Dialog>
  );
}

export default memo(PointChartPopup);
